import Icon from "@ant-design/icons";
import React from "react";

export default function ColumnsIcon() {
  return <Icon className="ac-icon" component={IconSvg} />;
}

const IconSvg = () => {
  return (
    <svg height="1em" viewBox="0 0 24 24" fill="none">
      <path
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.75C4 4.78351 4.78351 4 5.75 4H18.25C19.2165 4 20 4.78352 20 5.75V18.2502C20 19.2167 19.2165 20.0002 18.25 20.0002H5.75C4.78352 20.0002 4 19.2167 4 18.2502V5.75ZM5.75 5.5C5.61193 5.5 5.5 5.61193 5.5 5.75V18.2502C5.5 18.3883 5.61192 18.5002 5.75 18.5002H8.5V5.5H5.75ZM14 18.5002H10V5.5H14V18.5002ZM15.5 18.5002H18.25C18.3881 18.5002 18.5 18.3883 18.5 18.2502V5.75C18.5 5.61192 18.3881 5.5 18.25 5.5H15.5V18.5002Z"
        fill="currentColor"
      />
    </svg>
  );
};
